var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgVideoDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0009 6.30762L5.30859 9.53839L1.0009 12.7692V6.30762Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38552 5.23047C5.84706 5.23047 5.30859 5.7815 5.30859 6.46124V12.6151C5.30859 13.2948 5.88718 13.8459 6.6009 13.8459H13.7086C14.4223 13.8459 15.0009 13.2948 15.0009 12.6151V7.92278",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2308 2C11.4625 2 11.6683 2.14831 11.7416 2.36819L12.3295 4.132L14.0934 4.71994C14.3132 4.79323 14.4615 4.999 14.4615 5.23077C14.4615 5.46254 14.3132 5.66831 14.0934 5.7416L12.3295 6.32954L11.7416 8.09335C11.6683 8.31323 11.4625 8.46154 11.2308 8.46154C10.999 8.46154 10.7932 8.31323 10.7199 8.09335L10.132 6.32954L8.36818 5.7416C8.14831 5.66831 8 5.46254 8 5.23077C8 4.999 8.14831 4.79323 8.36818 4.71994L10.132 4.132L10.7199 2.36819C10.7932 2.14831 10.999 2 11.2308 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDownload);
export default __webpack_public_path__ + "static/media/video-download.0f8726f7e87a48ade224bf1fe3b7aaf6.svg";
export { ForwardRef as ReactComponent };